var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container-fluid",class:_vm.bgColor},[_c('a',{attrs:{"id":"logo","href":"https://getballoon.com"}},[_c('icon',{attrs:{"width":"140","height":"30","name":"balloon","color":_vm.iconColor}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }